// @flow
import { default as produce } from 'immer';

import * as actionTypes from './actions';
import type { Action } from './actions';
import type { IPersonInfo } from './IPersonInfo';
import type { Vehicle } from 'api/xws/login/entities/Vehicle';
import initialState from 'store/initialState';
import { RESET_APP_STATE } from 'store/actionTypes';

const reducer = (
  state: IPersonInfo = initialState.user.personInfo,
  action: Action
): IPersonInfo =>
  produce(
    state,
    (draft): IPersonInfo | void => {
      if (action.type === actionTypes.SET_PERSON_INFO) {
        const asPersonInfo: IPersonInfo = action.payload;
        return asPersonInfo;
      }
      if (
        state &&
        state.vehicles &&
        action.type === actionTypes.REMOVE_USER_VEHICLE
      ) {
        return {
          ...state,
          vehicles: state.vehicles.filter(
            ({ vehicleId }) => vehicleId !== action.payload
          )
        };
      }
      if (
        state &&
        state.vehicles &&
        action.type === actionTypes.UPDATE_USER_VEHICLES
      ) {
        const vehicle: Vehicle = action.payload;
        const vehicles =
          state.vehicles.filter(
            ({ vehicleId }) => vehicleId !== vehicle.vehicleId
          ) || [];
        vehicles.push(vehicle);
        return { ...state, vehicles };
      }
      if (state && action.type === actionTypes.UPDATE_PRIVACY_SETTINGS) {
        return {
          ...state,
          contactInfo: {
            ...state.contactInfo,
            ...action.payload
          }
        };
      }
      if (action.type === RESET_APP_STATE) {
        return initialState.user.personInfo;
      }
      return state;
    }
  );

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/user/personInfo/reducer.js